import {
  COMBINED_FOLDER_NAME_SEPARATOR,
  FOLDER_NAME_MAX_LENGTH,
} from "../../constants";
import { cellKeyOf } from "../cellKeyOf";
import { dimensionOf } from "../dimensionOf";
import { planCellKeyOf } from "../planCellKeyOf";
import type { FolderDraft } from "../../types";
import type { BuildFolderDrafts } from "./types";

export const buildFolderDrafts: BuildFolderDrafts = ({
  suggestion,
  structure,
}) => {
  if (structure !== "buildingAndLevel") {
    const values = dimensionOf({ suggestion, key: structure })?.values ?? [];
    return {
      folders: values.map(({ code, name, fileCode }) => ({
        key: code,
        name,
        fileCode,
      })),
      folderKeyByPlanId: new Map(
        suggestion.plans.map((plan) => [plan.floorPlanId, plan[structure]]),
      ),
    };
  }

  const folderKeyByPlanId = new Map<number, string | null>();
  const usedCellKeys = new Set<string>();
  for (const plan of suggestion.plans) {
    const cellKey = planCellKeyOf({ plan });
    folderKeyByPlanId.set(plan.floorPlanId, cellKey);
    if (cellKey !== null) usedCellKeys.add(cellKey);
  }

  const levels = dimensionOf({ suggestion, key: "level" })?.values ?? [];
  const buildings = dimensionOf({ suggestion, key: "building" })?.values ?? [];

  // Walking buildings, then levels, gives the table order without sorting.
  const folders: FolderDraft[] = [];
  for (const building of buildings) {
    for (const level of levels) {
      const key = cellKeyOf({
        buildingCode: building.code,
        levelCode: level.code,
      });
      if (!usedCellKeys.has(key)) continue;
      const name = `${building.name}${COMBINED_FOLDER_NAME_SEPARATOR}${level.name}`;
      const fileCode =
        building.fileCode === null || level.fileCode === null
          ? null
          : `${building.fileCode}${COMBINED_FOLDER_NAME_SEPARATOR}${level.fileCode}`;
      folders.push({
        key,
        name: name.slice(0, FOLDER_NAME_MAX_LENGTH),
        fileCode,
      });
    }
  }

  return { folders, folderKeyByPlanId };
};
